import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Input from '@mui/material/Input';
import { createCv,updateCv } from './services';
import { Alert, InputLabel, TextField, Typography} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { getCvsAction } from "./actions";
import CandidateService from '../../services/candidateService';
import CustomSelect from './CustomInput';
import { Select } from 'semantic-ui-react';
import { monthsInQuarter } from 'date-fns';

const UpdateCvDialog = ({ open, onClose, onUpload,cvData }) => {
  console.log("update cv dialog")
  const [file, setFile] = useState(null);
  const [nic, setNic] = useState('');
  const [name, setName] = useState('');
  const [occupation, setOccupation] = useState([]);
  const [passportNo, setPassportNo] = useState('');
  const [sector, setSector] = useState('');
  const [options, setOptions] = useState({});
  const [gcc, setGcc] = useState('');
  const [gccYears, setGccYears] = useState('');
  const [age, setAge] = useState('');
  const [experienceYears, setExperienceYears] = useState('');
  const [remark, setRemark] = useState('');

  const fetchOptions = async () => {
    try {
      const response = await CandidateService.getAllOptions();
      const data = response.data;
  
      const groupedOptions = {};
      data.forEach(option => {
        const { fieldName, label, value } = option;
        if (groupedOptions.hasOwnProperty(fieldName)) {
          groupedOptions[fieldName].push({ label, value });
        } else {
          groupedOptions[fieldName] = [{ label, value }];
        }
      });
  
      setOptions(prevOptions => ({
        ...prevOptions,
        ...groupedOptions
      }));
    } catch (error) {
      console.error('Error fetching options:', error);
    }
  };

  React.useEffect(() => {
    fetchOptions();
  }, []);

  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  const handleSectorChange = (event) => {
    const value = event.target.value;
    setSector(value);
  };

  const handleNicChange = (event) => {
    const value = event.target.value.toUpperCase();
    setNic(value);
  };

  const handlePassportNoChange = (event) => {
    const value = event.target.value.toUpperCase();
    setPassportNo(value);
  };
  

  const handleNameChange = (event) => {
    const value = event.target.value;
    setName(value);
  };
  
  const handleOccupationChange = (event) => {
    const selectedOccupations = event.target.value.split(",").map((occupation) => occupation.trim());
    setOccupation(selectedOccupations);
  };
  
  const handleRemarkChange = (event) => {
    const value = event.target.value;
    setRemark(value);
  };

  const [loading, setLoading] = useState(false);
  const [occupationCombineShow, setOccupationCombineShow] = useState('');


  const handleUpdate = () => {
    setLoading(true);
    console.log("update cv")
   // Create an array to hold the occupations
    const occupations = [cvData?.extraField?.occupation,occupation, occupation1, occupation2];

    // Filter out the empty or null occupations and join the remaining ones with a comma
    const occupationCombined = occupations.filter(Boolean).join(',');

    setOccupationCombineShow(occupationCombined);
    const id = cvData?.id;

    const data = {
        nic,
        sector,
        passportNo,
        extraField: {
          name,
          occupation,
          occupation1,
          occupation2,
          sector,
          fieldName:cvData.fileName,
          experienceYears,
          gcc,
          age,
          remark
        },
        fileName:cvData.fileName,
    };
    console.log(id,data)
    console.log(cvData)

    updateCv(id,data).then((response) => {
      alert("CV Updated Successfully");
      console.log(response);
      setNic('');
      setPassportNo('');
      setSector('');
      setLoading(false);
      setName('');
      setOccupation('');
      setOccupation1('');
      setOccupation2('');
      setExperienceYears('');
      setGcc('');
      setRemark('');
      setFile(null);
      dispatch(getCvsAction());
      onClose();
    }).catch((error) => {
     
      alert("Error",error);
      console.log(error);
      setFile(null);
      setLoading(false);
      setRemark('');
      setNic('');
      setSector('');
      setPassportNo('');
      setName('');
      setOccupation('');
      setExperienceYears('');
      setGcc('');
      setOccupation1('');
      setOccupation2('');
      onClose();
    });
  };

  const handleChange = (e, fieldName) => {
    const value = e.target.value;
    console.log(value);
  }

  const [occupation1, setOccupation1] = useState([]);
  const handleOccupation1Change = (event) => {  
    const selectedOccupations = event.target.value.split(",").map((occupation) => occupation.trim());
    console.log(selectedOccupations)
    setOccupation1(selectedOccupations);
  };

  const [occupation2, setOccupation2] = useState([]);

  const handleOccupation2Change = (event) => {
    const selectedOccupations = event.target.value.split(",").map((occupation) => occupation.trim());
    console.log(selectedOccupations)
    setOccupation2(selectedOccupations);
  };

  const [validated, setValidated] = useState(false);
  const [message, setMessage] = useState('');

  React.useEffect(() => {

    if(name?.length < 5){
      setValidated(false);
      setMessage('Name should be at least 5 characters long');
      return;
    }
    else if(nic?.length < 2){
      setValidated(false);
      setMessage('Please enter a valid NIC');
      return;
    }
    else if(nic?.length < 5){
      setValidated(true);
      setMessage('Please verify NIC before updataing');
      return;
    }

    //remove spaces fro nic
    const nicWithoutSpaces = nic.replace(/\s/g, '');
    setNic(nicWithoutSpaces);

    //only allow numbers and letters remove any other characters
    const nicWithoutSpecialCharacters = nicWithoutSpaces.replace(/[^a-zA-Z0-9]/g, '');
    setNic(nicWithoutSpecialCharacters);

    setValidated(true);

  }, [name, nic]);



  const calculateAgeFromNIC = (nic) => {
    // Extract the birth year (YY) from the NIC
    let birthYear = parseInt(nic.substr(0, 2), 10);
    
    // Check if the birth year is less than 100 (prior to 2000) or 100 or greater (from 2000 onwards)
    let fullBirthYear = birthYear < 100 ? 1900 + birthYear : 2000 + birthYear;
    
    // Get the current year
    const currentYear = new Date().getFullYear();
    
    // Calculate the age
    let age = currentYear - fullBirthYear;

    if (age>100){
      birthYear = parseInt(nic.substr(0, 4), 10);
      fullBirthYear = birthYear;
      age = currentYear - fullBirthYear;
    }
    
    return age;
  };

  React.useEffect(() => {
     setName(cvData?.extraField?.name);
     setNic(cvData?.nic);
     setPassportNo(cvData?.passportNo);
     setExperienceYears(cvData?.extraField?.experienceYears);
     setGcc(cvData?.extraField?.gcc);
     setSector(cvData?.extraField?.sector);
     setAge(cvData?.extraField?.age)
     setRemark(cvData?.extraField?.remark)
     console.log(options.sectors)
     setOccupation(cvData?.extraField?.occupation)
     setOccupation1(cvData?.extraField?.occupation1)
     setOccupation2(cvData?.extraField?.occupation2)
  }, [cvData]);

 
  useEffect(() => {
    const occupations = [cvData?.extraField?.occupation,occupation, occupation1, occupation2];
    console.log(occupation)
    console.log(occupation1)
    console.log(occupation2)
    // Filter out the empty or null occupations and join the remaining ones with a comma
    const occupationCombined = occupations.filter(Boolean).join(',');
    // Remove excess commas at the end

    const cleanedOccupationCombined = occupationCombined.replace(/,{2,}/g, ',');

    setOccupationCombineShow(cleanedOccupationCombined);
    console.log(cleanedOccupationCombined)
  }, [occupation,occupation1,occupation2]);
  
return (
<Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth sx={{ width: 'md' }}>
<DialogTitle>Update CV</DialogTitle>
<DialogContent>
    <div style={{ marginBottom: '16px',marginTop:'4px' }}>
    <TextField
        label="Name"
        fullWidth
        value={name}
        size='small'
        onChange={handleNameChange}
    />
    </div>
    <div style={{ marginBottom: '16px' }}>
    <TextField
        label="NIC"
        fullWidth
        size='small'
        value={nic}
        onChange={handleNicChange}
    />
    </div>
    <div style={{ marginBottom: '16px' }}>
    <TextField
        label="Passport No."
        fullWidth
        size='small'
        value={passportNo}
        onChange={handlePassportNoChange}
    />
    </div>
    <div style={{ marginBottom: '16px' }}>
    <TextField
        label="Age."
        fullWidth
        size='small'
        value={age}
        onChange={(e) => setAge(e.target.value)}
    />
    </div>
    <div style={{ marginBottom: '16px' }}>
    <TextField
        label="Experience Years"
        fullWidth
        size='small'
        value={experienceYears}
        onChange={(e) => setExperienceYears(e.target.value)}
    />
    </div>
    <div style={{ marginBottom: '16px' }}>
    <TextField
        label="Gcc Experience Years"
        fullWidth
        size='small'
        value={gcc}
        onChange={(e) => setGcc(e.target.value)}
    />      
    </div>

  

    <div style={{ marginBottom: '16px',marginTop:'16px' }}>
    <CustomSelect
            options={options.sectors}
            name="Sector"
            fetchOptions={fetchOptions}
            value={sector}
            onChange={(e) =>setSector(e.target.value)}
            fieldName="sectors"
            />
    </div>
    <div style={{ marginBottom: '16px',marginTop:'16px' }}>
    <CustomSelect
            options={options.designations}
            name="Add Occupation"
            fetchOptions={fetchOptions}
            value={occupation}
            onChange={(e) =>setOccupation(e.target.value)}
            fieldName="designations"
            />
    </div>
    <div style={{ marginBottom: '16px',marginTop:'16px' }}>
    <CustomSelect
            options={options.designations}
            name="Add Occupation"
            fetchOptions={fetchOptions}
            value={occupation1}
            onChange={(e) =>setOccupation1(e.target.value)}
            fieldName="designations"
            />
    </div>
    <div style={{ marginBottom: '16px',marginTop:'16px' }}>
    <CustomSelect
            options={options.designations}
            name="Add Occupation"
            fetchOptions={fetchOptions}
            value={occupation2}
            onChange={(e) =>setOccupation2(e.target.value)}
            fieldName="designations"
            />
    </div>
    <div style={{ marginBottom: '16px' }}>
    <TextField
        label="Remark"
        fullWidth
        size='small'
        value={remark}
        onChange={handleRemarkChange}
    />
    </div>

  

   
   


</DialogContent>
<Typography variant="body2" color="red" style={{
    padding:10
}}>
    {message}
</Typography>

<DialogActions>
    <Button onClick={onClose}>Cancel</Button>
    <Button onClick={handleUpdate} >
    {
        loading ? 'Updating..' : 'Update'
    }
    </Button>
</DialogActions>
</Dialog>

);
};

export default UpdateCvDialog;